import styled from "@emotion/styled";
import { Grid2 } from "@mui/material";

export const Wrapper = styled.div`
  width: 100%;
  overflow: hidden;
  z-index: 9;
  transition:
    opacity 0.3s ease,
    visibility 0.3s ease,
    max-height 0.3s ease,
    padding-top 0.3s ease;

  @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    position: absolute;
    top: 100%;
    right: 0;
    width: 610px;
    padding-top: ${props => (props.isOpen ? "20px" : "0")};

    overflow: visible;
  }
  padding-top: ${props => (props.isOpen ? "4px" : "0")};
  max-height: ${props => (props.isOpen ? "1200px" : "0")};
  visibility: ${props => (props.isOpen ? "visible" : "hidden")};
  opacity: ${props => (props.isOpen ? "1" : "0")};
  pointer-events: ${props => (props.isOpen ? "all" : "none")};
`;

export const List = styled(Grid2, {
  shouldForwardProp: prop => prop !== "isTools",
})`
  padding: 0;
  list-style: none;
  margin-top: 0;
  margin-bottom: 0;

  @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    margin-bottom: -16px;
  }
`;
